import type { FilterOption, SoftTagsResponse, Tags } from '../types/tags.types';
import { Colors } from '../../../../public/GlobalTokens';

// Helper function to extract unique values from tags and format for Select components
export const extractUniqueValues = (
  tags: Tags[],
  field: keyof Tags
): FilterOption[] => {
  const values = tags
    .map(tag => tag[field])
    .filter(
      (value): value is string =>
        value !== null && value !== undefined && value !== ''
    );

  const uniqueValues = Array.from(new Set(values)).sort();

  return uniqueValues.map(value => ({
    value: value,
    text: value,
  }));
};

//Further map response payload data to state params
export function softTagsResponseMapping(state: any, payload: SoftTagsResponse) {
  state.pagination = {
    count: payload.count,
    size: payload.size,
    page: payload.page,
    sort_by: payload.sort_by,
    sort_order: payload.sort_order,
  };

  const tags = payload.results;
  state.filtersOptions.productionSites = extractUniqueValues(tags, 'site');
  state.filtersOptions.areas = extractUniqueValues(tags, 'area');
  state.filtersOptions.productionUnits = extractUniqueValues(
    tags,
    'productionUnit'
  );
}

// Map an array of tag objects to an array of { name, id, source }
export function createSearchTagsResponseMapping(state: any, payload: any) {
  const response = payload.map(tag => ({
    name: tag.tag_name,
    id: tag.id,
    source: tag.source_type,
    type: tag.name,
  }));

  state.searchTags = response;
}

export const formatTimestamp = (timestamp: string) => {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return timestamp || 'N/A';
  }
  return date.toLocaleString();
};
interface StatusConfig {
  color: 'success' | 'destructive' | 'warning';
  icon: string;
  title: string;
  statusText: string;
  statusColor: string;
}

const STATUS_MAP: Record<string, StatusConfig> = {
  success: {
    color: 'success',
    icon: 'CheckCircle',
    title: 'View execution details',
    statusText: 'Succeeded',
    statusColor: Colors.colorType.success.dark,
  },
  error: {
    color: 'destructive',
    icon: 'ClearCircle',
    title: 'View execution details',
    statusText: 'Failed',
    statusColor: Colors.colorType.destructive.dark,
  },
  notAvailable: {
    color: 'warning',
    icon: 'NotAvailable',
    title: 'No execution history available',
    statusText: 'Not Available',
    statusColor: Colors.colorType.warning.dark,
  },
};

export const getStatusIcon = (status: string) => {
  const { color, icon, title } = STATUS_MAP[status] || STATUS_MAP.notAvailable;
  return { colorConcept: color, icon, title };
};

export const getStatusText = (status: string) => {
  return {
    statusText: STATUS_MAP[status]?.statusText || 'Not Available',
    statusColor:
      STATUS_MAP[status]?.statusColor || Colors.colorType.warning.dark,
  };
};
